<template>
	<div>
		<div class="px-16 py-2 w-full">
			<p @click="toggleMenu">X</p>
		</div>
		<div
			class="absolute bg-white border border-gray-300 flex flex-col h-screen w-1/2 z-40"
			:class="isMenuOpen ? 'block' : 'hidden'"
		>
			<router-link @click="toggleMenu" to="/">
				<img class="h-12 pl-4" src="../assets/logo.png">
			</router-link>
			<div class="space-y-2 py-2">
				<div class="hover:text-red-800 px-4">
					<router-link @click="toggleMenu" tag="a" to="/">Home</router-link>
				</div>
				<div class="hover:text-red-800 px-4">
					<router-link @click="toggleMenu" tag="a" to="/services">Our Services</router-link>
				</div>
				<div class="hover:text-red-800 px-4">
					<router-link @click="toggleMenu" tag="a" to="/contact">Contact Us</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'MobileNav',
	data() {
		return {
			isMenuOpen: false
		};
	},
	methods: {
		toggleMenu() {
			this.isMenuOpen = !this.isMenuOpen;
		}
	}
}

</script>